export { default as UpcomingEvents } from './UpcomingEvents';
